<template>
    <ai-grid-edit
        ref='gridRef'
        :meta='gridMeta'
        :args='gridArgs'
        @editGridMounted="onEditGridMounted"
        :to-remove-toolbar-items-names='removeGridToolbarBtns'
        @toolbar-button-click="onToolbarClickGrid"
        @user-data-changed="onUserDataChanged"
    ></ai-grid-edit>
</template>
<script>
export default {
    name: 'tep-ks-tarif-norm-view',
};
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';

const gridRef = ref(null);
const gridInstance = ref(null);
const addClickNew = ref(false);

const commonArgs = {
    depId: +getCookie('dep'),
};

const gridArgs = computed(() => {
    return {
        select: {
            select_args:{...commonArgs}
        },
        save: {
            update_args: {...commonArgs},
            insert_args: {...commonArgs},
            delete_args: {...commonArgs},
        },
    }
});

onMounted(async () => {
    await gridRef.value?.setDataSource();
});

const onEditGridMounted = async () => {
    gridInstance.value = gridRef?.value.gridInstance;
};

const onToolbarClickGrid = async (event) => {
    const  nameBtnclick = event?.item?.component?.name;
    if(nameBtnclick === 'add') addClickNew.value = true;
};

const onUserDataChanged = async (userData) => {
    if(addClickNew.value) {
        await getNewDataRow(userData);
    }
};

const getNewDataRow = async (userData) => {
    let insertEventData = userData.changes?.gridChanges?.filter(el => el.type === 'insert') ?? [];
    insertEventData = insertEventData.filter(el => el.data.kod_tarif_norm === null);
    if(insertEventData.length !== 0) {
        insertEventData.map(item => {
            item.data['kod_tarif_stav_tip'] = 1;
            item.data['name_tarif_stav_tip'] = 'ГВС на человека';
        })
        gridInstance.value.refresh();
        addClickNew.value = false;
    }
};

const removeGridToolbarBtns = [ 'edit', 'choice', 'show-column-chooser', 'searchPanel', 'copy', 'export'];

const gridMeta = {
    "keyExpr": "kod_tarif_norm",
    "columns": [
        {
            "name": "kod_tarif_norm",
            "caption": "Код",
            "dataField": "kod_tarif_norm",
            "allowEditing": false,
            "width": 150,
            "index": 1,
            "visible": false
        },
        {
            "name": "norm_name",
            "caption": "Наименование норматива",
            "dataField": "norm_name",
            "allowEditing": true,
            "width": '25%',
            "index": 2,
            "visible": true
        },
        {
            "name": "kod_tarif_stav_tip",
            "caption": "Тип норматива код",
            "dataField": "kod_tarif_stav_tip",
            "allowEditing": false,
            "width": 300,
            "index": 3,
            "visible": false
        },
        {
            "name": "name_tarif_stav_tip",
            "caption": "Тип норматива",
            "dataField": "name_tarif_stav_tip",
            "allowEditing": false,
            "width": '20%',
            "index": 4,
            "visible": true
        },
        {
            "name": "norm_m3",
            "caption": "Тип ставки тарифа",
            "dataField": "norm_m3",
            "allowEditing": true,
            'dataType': 'number',
            "width": '10%',
            "index": 5,
            "visible": true
        },
        {
            "name": "dat_beg",
            "caption": "Дата начала действия",
            "dataField": "dat_beg",
            "allowEditing": true,
            "width": '10%',
            "index": 6,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
            "visible": true
        },
        {
            "name": "dat_end",
            "caption": "Дата окончания действия",
            "dataField": "dat_end",
            "allowEditing": true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
            "width": '10%',
            "index": 7,
            "visible": true
        },
        {
            'name': 'kod_nrasx',
            'caption': 'Наименование категории группы водопотребителя',
            'dataField': 'kod_nrasx',
            'allowEditing': true,
            "width": '25%',
            'index': 8,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_nrasx"
            },
            "component": {
                "name": "lookup-ds-nrasx",
                "id": "kod",
                "text": "name",
                "minHeight": '200px'
            }
        },
    ],
    "api": {
        "select": 'tep-nsi./tep-nsi/tep-ks-tarif-norm/select/get',
        "save": 'tep-nsi./tep-nsi/tep-ks-tarif-norm/save/set',
    },
    "viewId": "view-tep-ks-tarif-norm",
    isFilterPanelVisible: false,
}
</script>
<style scoped>

</style>
